<template>
  <div :class="{'page-bottom': is_fixed}" style="margin-top:3vw">
    <div class='home_content'>
      <div class='home_title'>
        <img src="https://d105xpbtjj9cjp.cloudfront.net/officialweb/images/home_title_icon.png"  class='home-title-icon'>
        <p>{{$t('home.join_we')}}</p>
      </div>
      <div class="msg_content">
        <el-image v-if="$i18n.locale==='zh'" :src="join_bottom" style=" width: 100%; margin-bottom: 3%"></el-image>
        <el-image v-else-if="$i18n.locale==='en'" :src="join_bottom_en" style=" width: 100%; margin-bottom: 3%"></el-image>
      </div>
    </div>
    <div id="bottom" v-if="!is_pc">
      <el-image v-if="$i18n.locale==='zh'" :src="src" class="bottom-img"></el-image>
      <el-image v-else-if="$i18n.locale==='en'" :src="src_en" class="bottom-img"></el-image>
      <div class="beian">
        <div class="res-class">
          <a href="https://spinxgames.pactsafe.io/spinx-games#responsible-gaming"  target="_blank" style="color:#8c8b9a;font-weight: 800;text-decoration: revert;">
            Responsible Gaming
          </a>
        </div>
        <div>
          <a href="/ethics"  style="color:#8c8b9a;font-weight: 800;text-decoration: revert;font-size: 14px">
            Code of Ethics
          </a>
        </div>
        <a target="_blank" href="http://beian.miit.gov.cn/publish/query/indexFirst.action">京ICP备20014890号-2</a>
      </div>
    </div>
    <div v-else class="new-bottom" >
      <div v-if="$i18n.locale==='zh'">
        <img
          src="https://d105xpbtjj9cjp.cloudfront.net/officialweb/images/logo_nav.png"
          alt="Logo"
          style="height: 3.5vw; margin-top: 0.5vw"
        />
        <div style="display: flex;align-items: center;justify-content: space-between;">
          <div  style="text-align: left;margin-top: 5px">
            <div class="contact-info">联系方式</div>
            <table>
              <tr>
                <td class="icon-td">
                  <i class="el-icon-location-outline" style="color: #f3c258"></i>
                </td>
                <td>
                  <span class="location-text">北京市朝阳区红军营南路36号A座（北楼）三层</span>
                </td>
              </tr>
              <tr>
                <td class="icon-td">
                  <i class="el-icon-message" style="color: #f3c258"></i>
                </td>
                <td>
                  <span class="location-text">hr@bolegames.com</span>
                </td>
              </tr>
            </table>
          </div>
        </div>
        <div style="display: flex;align-items: center;justify-content: space-between;margin-top: 10px">
          <div class="copyright">
            Copyright @ 2018 BOLE
            <span style="margin-left: 15px">京ICP备20014890号-2</span>
          </div>
          <div>
            <a href="https://spinxgames.pactsafe.io/spinx-games#responsible-gaming"  target="_blank" style="color:#8c8b9a;font-weight: 800;text-decoration: revert;font-size: 15px">
              Responsible Gaming
            </a>
            <span style="margin: 0 10px"> </span>
            <a href="/ethics"  style="color:#8c8b9a;font-weight: 800;text-decoration: revert;font-size: 15px">
              道德准则
            </a>
          </div>
        </div>
      </div>
      <div v-if="$i18n.locale==='en'">
        <img
          src="https://d105xpbtjj9cjp.cloudfront.net/officialweb/images/logo_nav_en.png"
          alt="Logo"
          style="height: 3.5vw; margin-top: 0.5vw"
        />
        <div style="display: flex;align-items: center;justify-content: space-between;">
          <div style="text-align: left;margin-top: 5px">
            <div class="contact-info-en">CONTACT INFORMATION</div>
            <table>
              <tr>
                <td class="icon-td">
                  <i class="el-icon-location-outline" style="color: #f3c258"></i>
                </td>
                <td>
                  <span class="location-text-en">Floor3, Building A, No.36, Hongjunying South Road, <br> Chaoyang District, Beijing</span>
                </td>
              </tr>
              <tr>
                <td class="icon-td">
                  <i class="el-icon-message" style="color: #f3c258"></i>
                </td>
                <td>
                  <span class="location-text-en">hr@bolegames.com</span>
                </td>
              </tr>
            </table>
          </div>
        </div>
        <div style="display: flex;align-items: center;justify-content: space-between;margin-top: 10px">
          <div class="copyright">
            Copyright @ 2018 BOLE
            <span style="margin-left: 15px">京ICP备20014890号-2</span>
          </div>
          <div>
            <a href="https://spinxgames.pactsafe.io/spinx-games#responsible-gaming"  target="_blank" style="color:#8c8b9a;font-weight: 800;text-decoration: revert;font-size: 15px">
              Responsible Gaming
            </a>
            <span style="margin: 0 10px"> </span>
            <a href="/ethics"  style="color:#8c8b9a;font-weight: 800;text-decoration: revert;font-size: 15px">
              Code of Ethics
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>

</template>


<script>
export default {
  data() {
    return {
      src: 'https://d105xpbtjj9cjp.cloudfront.net/officialweb/images/bottom.png',
      src_en: 'https://d105xpbtjj9cjp.cloudfront.net/officialweb/images/bottom_en.png',
      text: 'https://d105xpbtjj9cjp.cloudfront.net/officialweb/images/msg_text.png',
      text_en: 'https://d105xpbtjj9cjp.cloudfront.net/officialweb/images/msg_text_en.png',
      input: ''
    };
  },
  computed: {
    is_pc() {
      return document.documentElement.clientWidth > 992;
    },
    //英文版首页、关于页，内容不足
    is_fixed() {
      const cur_path = this.$route.path.split('/')[1];
      return false;
      // return cur_path === '' && this.$i18n.locale === 'en' ? true : false
    },
    join_bottom() {
      return 'https://d105xpbtjj9cjp.cloudfront.net/officialweb/img_bole/bottom_pc.png';
    },
    join_bottom_en() {
      return 'https://d105xpbtjj9cjp.cloudfront.net/officialweb/img_bole/bottom_pc_en.png';
    }
  },
  methods: {
    clickBtn() {
      this.$router.push('/ethics');
    }
  }
};
</script>

<style lang="less" scoped>
@import url('../assets/style/colors.less');
.beian {
  font-size: 1.2vw;
  color: white;
  padding-bottom: 20px;
  font-family: auto;
  cursor: pointer;
  a {
    text-decoration:none;
    color: #828181;
  }
}
#bottom {
  width: 100%;
  margin: 4vw 0 0 0;
  padding: 2vw 0 1vw;
  background: @lanmu;
  position: relative;
}
.bottom-img {
  width: 70%
}
.msg_content {
  width: 100%;
  // padding: 2.5vw 2.2vw;
  // background: @lanmu;
  position: relative;
  overflow: hidden;
  .msg {
    width: 24vw;
    height: 3.5vw;
    margin-top: 1vw;
    background: white;
    display: flex;
    float: right;
    align-items: center;
    overflow: hidden;
    .msg-input {
      position: relative;
      width: 79%;
      float: left;
    }
    .msg-icon {
      float: right;
      margin-right: 1px;
    }
  }
  .msg_content_intro {
    position: relative;
    float: left;
    width: 50%;
    .msg-text {
      width: 70%;
    }
  }
}
.msg-input {
  display: block;
}
.msg-input-mobile {
  display: none;
}
.over {
  overflow:hidden;
}
.msg-icon-img {
  height: 3vw;
  margin-top: 5px;
}
.res-class {
 position: absolute;
  left: 27%;
}

@media screen and (max-width: 992px) {
  .res-class {
    left: 0%;
    position: relative;
  }
  .beian {
    font-size: 12px;
    padding-bottom:2px;
  }
  .home_title p {
    bottom: 2.3vw;
  }
  .home-title-icon {
    height: 6.5vw;
  }
  .msg_content {
    .msg {
      width: 50%;
      height: 5.5vw;
      margin-top: -1vw;
      margin-top: 3vw;
    }
    .msg_content_intro {
      width: 45%;
      .msg-text {
        width: 85%;
      }
    }
  }
  .msg-input {
    display: none;
  }
  .msg-input-mobile {
    display: block;
  }
  .msg-icon-img {
    height: 5vw;
  }
  .bottom-img {
    width: 90%
  }
  .page-bottom {
    bottom: 0;
    margin-top: 3vw;
    position: fixed;
  }
}

.new-bottom {
  width: 100%;
  margin: 4vw 0 0 0;
  padding: 2vw 24vw;
  background: @lanmu;
  position: relative;
  box-sizing: border-box;
  td {
    line-height: 12px;
  }
}
.copyright {
  color: #8a8a90;
  font-weight: 800;
  font-size: 15px;
  font-family: fangsong;
}
.contact-info {
  color: #fff6c1;
  font-weight: 800;
  font-size: 20px;
  font-family: fangsong;
  margin-bottom: 10px;
}
.contact-info-en {
  color: #fff6c1;
  font-weight: 800;
  font-size: 16px;
  font-family: fangsong;
  margin-bottom: 10px;
}
.location-text {
  color: #bdbad6;
  font-weight: 800;
  font-size: 15px;
  font-family: fangsong;
  line-height: 12px;
}
.location-text-en {
  color: #bdbad6;
  font-weight: 800;
  font-size: 14px;
  font-family: fangsong;
  line-height: 12px;
}
.icon-td {
  width: 30px;
}
</style>





// WEBPACK FOOTER //
// src/components/Bottom.vue